module.exports = __webpack_public_path__ + "static/media/success_icon.b876c369.svg";